function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
// Static file — ApiException is NSwag template boilerplate with no C# source type.
export class ApiException extends Error {
    static isApiException(obj) {
        return obj.isApiException === true;
    }
    constructor(message, status, response, headers, result){
        super(), _define_property(this, "message", void 0), _define_property(this, "status", void 0), _define_property(this, "response", void 0), _define_property(this, "headers", void 0), _define_property(this, "result", void 0), _define_property(this, "isApiException", true);
        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }
}
export function throwException(message, status, response, headers, result) {
    if (result !== null && result !== undefined) throw result;
    else throw new ApiException(message, status, response, headers, null);
}
